import React, { useEffect } from 'react'
import $ from 'jquery';
import WOW from 'wowjs';
import Parallax from 'parallax-js';

export default function Menu() {
    useEffect(() => {
        if ($('.mobile-menu').length) {

            var mobileMenuContent = $('.main-header .menu-area .main-menu').html();

            if (!$('.mobile-menu .menu-box .menu-outer').hasClass('content-added')) {
                $('.mobile-menu .menu-box .menu-outer').append(mobileMenuContent).addClass('content-added');
            }

            // if (!$('.sticky-header .main-menu').hasClass('content-added')) {
            //     $('.sticky-header .main-menu').append(mobileMenuContent).addClass('content-added');
            // }

            // $('.current').css('color', 'red');
            // $('.current *').css('color', 'red');

            // Dropdown Button
            $('.mobile-menu li.dropdown .dropdown-btn').on('click', function () {
                $(this).toggleClass('open');
                $(this).prev('ul').slideToggle(500);
            });

            // Menu Toggle Btn
            $('.mobile-nav-toggler').on('click', function () {
                $('body').addClass('mobile-menu-visible');
            });

            // Menu Toggle Btn
            $('.mobile-menu .menu-backdrop,.mobile-menu .close-btn').on('click', function () {
                $('body').removeClass('mobile-menu-visible');
            });
        }
    }, [])
    return (
        <div className="mobile-menu">
            <div className="menu-backdrop" />
            <div className="close-btn">
                <i className="fas fa-times" />
            </div>
            <nav className="menu-box">
                <div class="nav-logo text-center">
                    <a href="#">
                        <img src="assets/images/logo-light.svg" class="img-fluid" alt="Logo" title="Logo" />
                    </a>
                </div>

                <div className="menu-outer">
                    {/*Here Menu Will Come Automatically Via Javascript / Same Menu as in Header*/}
                </div>
                <div style={{ paddingTop: "16px" }} className="contact-info">
                    <h4>Contact Info</h4>
                    <ul>
                        <li> Kesar Tower, Ring Road No. - 2, Gondwara, Bhanpuri, Bilaspur Raod, Raipur, Chhattisgarh,
                            <br />India - 492003</li>
                        <li>
                            <a href="tel:+917880128802">+91 7880128802</a>
                        </li>
                        <li>
                            <a href="mailto:info@example.com">info@fixingdots.com</a>
                        </li>
                    </ul>
                </div>
                <div style={{ paddingTop: "6px" }} className="social-links">
                    <ul className="clearfix">
                        <li>
                            <a target='_blank' href="https://www.facebook.com/fixingdots?mibextid=ZbWKwL">
                                <i style={{ fontSize: "22px" }} className="fab fa-facebook-f" />
                            </a>
                        </li>
                        <li style={{ marginLeft: "9%" }}>
                            <a target='_blank' href="https://www.instagram.com/fixingdots?igsh=Zm14bmIzZ3AwYjB5">
                                <i style={{ fontSize: "22px" }} className="fab fa-instagram" />
                            </a>
                        </li>
                        <li style={{ marginLeft: "9%" }}>
                            <a target='_blank' href="https://fixingdots.com/">
                                <i style={{ fontSize: "22px" }} className="fa fa-link" />
                            </a>
                        </li>

                    </ul>
                </div>
            </nav>
        </div>
    )
}
